import { Link } from "react-router-dom";

function PORGLogo() {
    return ( 
      <Link to="/">
    <svg
        className="school-logo"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        width="500"
        zoomAndPan="magnify"
        viewBox="0 0 375 374.999991"
        height="500"
        preserveAspectRatio="xMidYMid meet"
        version="1.0"
      >
        <defs>
          <clipPath id="02bacaab99">
            <path
              d="M 2.515625 0 L 375 0 L 375 375 L 2.515625 375 Z M 2.515625 0 "
              clipRule="nonzero"
            />
          </clipPath>
        </defs>
        <rect
          x="-37.5"
          width="450"
          fill="#ffffff"
          y="-37.499999"
          height="449.999989"
          fillOpacity="1"
        />
        <rect
          x="-37.5"
          width="450"
          fill="#ffffff"
          y="-37.499999"
          height="449.999989"
          fillOpacity="1"
        />
        <g clipPath="url(#02bacaab99)">
          <path
            fill="#ffffff"
            d="M -31.503906 -24.277344 L -31.503906 417.085938 L 342.195312 417.085938 C 372.347656 417.085938 397.355469 439.109375 401.921875 468.011719 L 407.742188 468.011719 L 407.742188 36.21875 C 407.742188 2.796875 380.667969 -24.277344 347.246094 -24.277344 Z M -31.503906 -24.277344 "
            fillOpacity="1"
            fillRule="nonzero"
          />
        </g>
        <path
          fill="#196aac"
          d="M 198.601562 339.902344 L 198.601562 273.78125 L 188.746094 257.667969 L 177.683594 273.78125 L 177.683594 339.902344 L 167.730469 343.75 L 167.730469 351.585938 L 208.507812 351.585938 L 208.507812 343.75 Z M 198.601562 339.902344 "
          fillOpacity="1"
          fillRule="nonzero"
        />
        <path
          fill="#196aac"
          d="M 188.359375 192.847656 C 197.113281 181.976562 202.066406 167.648438 202.066406 152.882812 C 202.066406 137.015625 197.113281 122.25 188.359375 111.816406 C 179.609375 122.25 174.65625 137.015625 174.65625 152.882812 C 174.65625 167.597656 179.609375 181.976562 188.359375 192.847656 Z M 188.359375 192.847656 "
          fillOpacity="1"
          fillRule="nonzero"
        />
        <path
          fill="#196aac"
          d="M 119.976562 92.4375 C 117.285156 105.804688 119.976562 121.144531 127.625 135.042969 C 134.691406 147.980469 145.898438 158.171875 158.785156 163.558594 C 161.285156 149.804688 158.785156 134.851562 151.714844 121.914062 C 144.117188 107.96875 132.671875 97.4375 119.976562 92.4375 Z M 119.976562 92.4375 "
          fillOpacity="1"
          fillRule="nonzero"
        />
        <path
          fill="#196aac"
          d="M 129.59375 39.203125 C 126.902344 52.570312 129.59375 67.910156 137.242188 81.808594 C 144.164062 94.550781 155.660156 104.988281 168.402344 110.324219 C 170.902344 96.570312 168.402344 81.617188 161.332031 68.679688 C 153.734375 54.734375 142.289062 44.15625 129.59375 39.203125 Z M 129.59375 39.203125 "
          fillOpacity="1"
          fillRule="nonzero"
        />
        <path
          fill="#196aac"
          d="M 225.195312 121.914062 C 218.125 134.851562 215.625 149.804688 218.125 163.558594 C 231.015625 158.222656 242.265625 147.980469 249.289062 135.042969 C 256.886719 121.097656 259.578125 105.804688 256.933594 92.4375 C 244.238281 97.4375 232.792969 107.96875 225.242188 121.914062 Z M 225.195312 121.914062 "
          fillOpacity="1"
          fillRule="nonzero"
        />
        <path
          fill="#196aac"
          d="M 214.664062 68.679688 C 207.59375 81.617188 205.09375 96.570312 207.546875 110.324219 C 220.433594 104.988281 231.6875 94.746094 238.707031 81.808594 C 246.308594 67.863281 249 52.570312 246.355469 39.203125 C 233.660156 44.15625 222.261719 54.734375 214.664062 68.679688 Z M 214.664062 68.679688 "
          fillOpacity="1"
          fillRule="nonzero"
        />
        <path
          fill="#196aac"
          d="M 277.226562 224.246094 C 264.292969 217.179688 249.335938 214.679688 235.582031 217.179688 C 240.921875 230.066406 251.164062 241.320312 264.101562 248.339844 C 278.046875 255.9375 293.339844 258.632812 306.707031 255.988281 C 301.753906 243.292969 291.175781 231.894531 277.226562 224.296875 Z M 277.226562 224.246094 "
          fillOpacity="1"
          fillRule="nonzero"
        />
        <path
          fill="#196aac"
          d="M 98.625 224.246094 C 84.679688 231.847656 74.101562 243.292969 69.148438 255.9375 C 82.515625 258.632812 97.855469 255.9375 111.753906 248.292969 C 124.691406 241.222656 134.886719 230.019531 140.269531 217.128906 C 126.515625 214.628906 111.5625 217.128906 98.625 224.199219 Z M 98.625 224.246094 "
          fillOpacity="1"
          fillRule="nonzero"
        />
        <path
          fill="#196aac"
          d="M 74.871094 178.226562 C 60.539062 171.445312 45.054688 169.617188 31.878906 173.082031 C 37.601562 185.441406 48.804688 196.261719 63.136719 203.039062 C 76.457031 209.339844 91.507812 210.976562 105.117188 207.707031 C 99.058594 195.152344 88.191406 184.527344 74.871094 178.226562 Z M 74.871094 178.226562 "
          fillOpacity="1"
          fillRule="nonzero"
        />
        <path
          fill="#196aac"
          d="M 344.359375 173.082031 C 331.183594 169.617188 315.699219 171.445312 301.367188 178.226562 C 288.046875 184.527344 277.179688 195.152344 271.121094 207.707031 C 284.683594 210.976562 299.78125 209.339844 313.101562 203.039062 C 327.433594 196.261719 338.6875 185.488281 344.359375 173.082031 Z M 344.359375 173.082031 "
          fillOpacity="1"
          fillRule="nonzero"
        />
        <path
          fill="#196aac"
          d="M 290.980469 131.003906 C 276.796875 134.996094 264.339844 143.699219 256.261719 155.046875 C 269.101562 160.53125 284.25 161.394531 298.433594 157.402344 C 313.679688 153.125 326.566406 144.324219 334.214844 133.070312 C 321.804688 127.492188 306.226562 126.722656 290.980469 131.003906 Z M 290.980469 131.003906 "
          fillOpacity="1"
          fillRule="nonzero"
        />
        <path
          fill="#196aac"
          d="M 86.941406 131.003906 C 71.648438 126.722656 56.113281 127.492188 43.707031 133.070312 C 51.402344 144.371094 64.242188 153.125 79.484375 157.402344 C 93.671875 161.394531 108.820312 160.53125 121.660156 155.046875 C 113.582031 143.652344 101.125 134.996094 86.941406 131.003906 Z M 86.941406 131.003906 "
          fillOpacity="1"
          fillRule="nonzero"
        />
        <path
          fill="#196aac"
          d="M 74.390625 58.628906 C 71.503906 69.976562 73.042969 83.25 78.859375 95.609375 C 84.152344 106.910156 93.382812 116.480469 103.964844 121.820312 C 106.65625 110.230469 105.214844 97.003906 99.925781 85.75 C 94.152344 73.394531 84.96875 63.679688 74.390625 58.628906 Z M 74.390625 58.628906 "
          fillOpacity="1"
          fillRule="nonzero"
        />
        <path
          fill="#196aac"
          d="M 277.371094 85.800781 C 272.082031 97.050781 270.6875 110.277344 273.332031 121.867188 C 283.960938 116.480469 293.144531 106.910156 298.433594 95.65625 C 304.207031 83.300781 305.792969 70.027344 302.90625 58.675781 C 292.328125 63.773438 283.144531 73.488281 277.371094 85.800781 Z M 277.371094 85.800781 "
          fillOpacity="1"
          fillRule="nonzero"
        />
        <path
          fill="#196aac"
          d="M 188.839844 92.292969 C 196.148438 82.769531 200.191406 70.410156 199.996094 57.765625 C 199.804688 44.105469 195.429688 31.507812 187.878906 22.515625 C 180.570312 31.699219 176.53125 44.441406 176.722656 58.101562 C 176.914062 70.554688 181.386719 83.058594 188.839844 92.339844 Z M 188.839844 92.292969 "
          fillOpacity="1"
          fillRule="nonzero"
        />
        <path
          fill="#196aac"
          d="M 145.464844 238.722656 C 137.046875 250.550781 132.671875 265.410156 133.441406 279.214844 C 146.859375 275.460938 159.21875 266.664062 167.777344 254.640625 C 177.011719 241.703125 181.53125 226.84375 180.425781 213.234375 C 167.25 216.648438 154.648438 225.785156 145.417969 238.722656 Z M 145.464844 238.722656 "
          fillOpacity="1"
          fillRule="nonzero"
        />
        <path
          fill="#196aac"
          d="M 230.824219 238.722656 C 221.589844 225.785156 208.988281 216.648438 195.8125 213.234375 C 194.753906 226.84375 199.277344 241.703125 208.460938 254.640625 C 217.019531 266.664062 229.378906 275.460938 242.84375 279.214844 C 243.660156 265.269531 239.382812 250.695312 230.824219 238.722656 Z M 230.824219 238.722656 "
          fillOpacity="1"
          fillRule="nonzero"
        />
        <path
          fill="#196aac"
          d="M 276.027344 176.878906 C 262.992188 171.878906 247.847656 171.542969 233.804688 176.0625 C 218.703125 180.917969 206.199219 190.152344 198.890625 201.695312 C 211.492188 206.839844 227.070312 207.03125 242.171875 202.175781 C 256.214844 197.65625 268.332031 188.566406 275.976562 176.878906 Z M 276.027344 176.878906 "
          fillOpacity="1"
          fillRule="nonzero"
        />
        <path
          fill="#196aac"
          d="M 143.109375 175.773438 C 129.066406 171.253906 113.917969 171.589844 100.886719 176.589844 C 108.53125 188.277344 120.699219 197.367188 134.691406 201.886719 C 149.839844 206.742188 165.375 206.550781 177.972656 201.40625 C 170.710938 189.863281 158.207031 180.632812 143.058594 175.773438 Z M 143.109375 175.773438 "
          fillOpacity="1"
          fillRule="nonzero"
        />
      </svg>
      </Link> );
}

export default PORGLogo;